module.exports = __webpack_public_path__ + "static/img/selectPack.1a98c49.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/selectPack.svg
// module id = /NQ1
// module chunks = 1